/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiNurseryManagerItemsCreateItemPost } from '../fn/items/api-nursery-manager-items-create-item-post';
import { ApiNurseryManagerItemsCreateItemPost$Params } from '../fn/items/api-nursery-manager-items-create-item-post';
import { apiNurseryManagerItemsCreateItemPost$Plain } from '../fn/items/api-nursery-manager-items-create-item-post-plain';
import { ApiNurseryManagerItemsCreateItemPost$Plain$Params } from '../fn/items/api-nursery-manager-items-create-item-post-plain';
import { apiNurseryManagerItemsDeleteItemDelete } from '../fn/items/api-nursery-manager-items-delete-item-delete';
import { ApiNurseryManagerItemsDeleteItemDelete$Params } from '../fn/items/api-nursery-manager-items-delete-item-delete';
import { apiNurseryManagerItemsDeleteItemDelete$Plain } from '../fn/items/api-nursery-manager-items-delete-item-delete-plain';
import { ApiNurseryManagerItemsDeleteItemDelete$Plain$Params } from '../fn/items/api-nursery-manager-items-delete-item-delete-plain';
import { apiNurseryManagerItemsGetItemPost } from '../fn/items/api-nursery-manager-items-get-item-post';
import { ApiNurseryManagerItemsGetItemPost$Params } from '../fn/items/api-nursery-manager-items-get-item-post';
import { apiNurseryManagerItemsGetItemPost$Plain } from '../fn/items/api-nursery-manager-items-get-item-post-plain';
import { ApiNurseryManagerItemsGetItemPost$Plain$Params } from '../fn/items/api-nursery-manager-items-get-item-post-plain';
import { apiNurseryManagerItemsGetItemsByCategoryPost } from '../fn/items/api-nursery-manager-items-get-items-by-category-post';
import { ApiNurseryManagerItemsGetItemsByCategoryPost$Params } from '../fn/items/api-nursery-manager-items-get-items-by-category-post';
import { apiNurseryManagerItemsGetItemsByCategoryPost$Plain } from '../fn/items/api-nursery-manager-items-get-items-by-category-post-plain';
import { ApiNurseryManagerItemsGetItemsByCategoryPost$Plain$Params } from '../fn/items/api-nursery-manager-items-get-items-by-category-post-plain';
import { apiNurseryManagerItemsGetItemsPost } from '../fn/items/api-nursery-manager-items-get-items-post';
import { ApiNurseryManagerItemsGetItemsPost$Params } from '../fn/items/api-nursery-manager-items-get-items-post';
import { apiNurseryManagerItemsGetItemsPost$Plain } from '../fn/items/api-nursery-manager-items-get-items-post-plain';
import { ApiNurseryManagerItemsGetItemsPost$Plain$Params } from '../fn/items/api-nursery-manager-items-get-items-post-plain';
import { apiNurseryManagerItemsUpdateItemPatch } from '../fn/items/api-nursery-manager-items-update-item-patch';
import { ApiNurseryManagerItemsUpdateItemPatch$Params } from '../fn/items/api-nursery-manager-items-update-item-patch';
import { apiNurseryManagerItemsUpdateItemPatch$Plain } from '../fn/items/api-nursery-manager-items-update-item-patch-plain';
import { ApiNurseryManagerItemsUpdateItemPatch$Plain$Params } from '../fn/items/api-nursery-manager-items-update-item-patch-plain';
import { CreateItemCommandResult } from '../models/create-item-command-result';
import { DeleteItemCommandResult } from '../models/delete-item-command-result';
import { GetItemQueryResult } from '../models/get-item-query-result';
import { GetItemsByCategoryQueryResult } from '../models/get-items-by-category-query-result';
import { GetItemsQueryResult } from '../models/get-items-query-result';
import { UpdateItemCommandResult } from '../models/update-item-command-result';

@Injectable({ providedIn: 'root' })
export class ItemsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiNurseryManagerItemsGetItemsPost()` */
  static readonly ApiNurseryManagerItemsGetItemsPostPath = '/api/NurseryManager/Items/GetItems';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerItemsGetItemsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerItemsGetItemsPost$Plain$Response(params?: ApiNurseryManagerItemsGetItemsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetItemsQueryResult>> {
    return apiNurseryManagerItemsGetItemsPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerItemsGetItemsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerItemsGetItemsPost$Plain(params?: ApiNurseryManagerItemsGetItemsPost$Plain$Params, context?: HttpContext): Observable<GetItemsQueryResult> {
    return this.apiNurseryManagerItemsGetItemsPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetItemsQueryResult>): GetItemsQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerItemsGetItemsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerItemsGetItemsPost$Response(params?: ApiNurseryManagerItemsGetItemsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetItemsQueryResult>> {
    return apiNurseryManagerItemsGetItemsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerItemsGetItemsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerItemsGetItemsPost(params?: ApiNurseryManagerItemsGetItemsPost$Params, context?: HttpContext): Observable<GetItemsQueryResult> {
    return this.apiNurseryManagerItemsGetItemsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetItemsQueryResult>): GetItemsQueryResult => r.body)
    );
  }

  /** Path part for operation `apiNurseryManagerItemsGetItemPost()` */
  static readonly ApiNurseryManagerItemsGetItemPostPath = '/api/NurseryManager/Items/GetItem';

  /**
   * get all users of the company.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerItemsGetItemPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerItemsGetItemPost$Plain$Response(params?: ApiNurseryManagerItemsGetItemPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetItemQueryResult>> {
    return apiNurseryManagerItemsGetItemPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * get all users of the company.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerItemsGetItemPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerItemsGetItemPost$Plain(params?: ApiNurseryManagerItemsGetItemPost$Plain$Params, context?: HttpContext): Observable<GetItemQueryResult> {
    return this.apiNurseryManagerItemsGetItemPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetItemQueryResult>): GetItemQueryResult => r.body)
    );
  }

  /**
   * get all users of the company.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerItemsGetItemPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerItemsGetItemPost$Response(params?: ApiNurseryManagerItemsGetItemPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetItemQueryResult>> {
    return apiNurseryManagerItemsGetItemPost(this.http, this.rootUrl, params, context);
  }

  /**
   * get all users of the company.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerItemsGetItemPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerItemsGetItemPost(params?: ApiNurseryManagerItemsGetItemPost$Params, context?: HttpContext): Observable<GetItemQueryResult> {
    return this.apiNurseryManagerItemsGetItemPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetItemQueryResult>): GetItemQueryResult => r.body)
    );
  }

  /** Path part for operation `apiNurseryManagerItemsGetItemsByCategoryPost()` */
  static readonly ApiNurseryManagerItemsGetItemsByCategoryPostPath = '/api/NurseryManager/Items/GetItemsByCategory';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerItemsGetItemsByCategoryPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerItemsGetItemsByCategoryPost$Plain$Response(params?: ApiNurseryManagerItemsGetItemsByCategoryPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetItemsByCategoryQueryResult>> {
    return apiNurseryManagerItemsGetItemsByCategoryPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerItemsGetItemsByCategoryPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerItemsGetItemsByCategoryPost$Plain(params?: ApiNurseryManagerItemsGetItemsByCategoryPost$Plain$Params, context?: HttpContext): Observable<GetItemsByCategoryQueryResult> {
    return this.apiNurseryManagerItemsGetItemsByCategoryPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetItemsByCategoryQueryResult>): GetItemsByCategoryQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerItemsGetItemsByCategoryPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerItemsGetItemsByCategoryPost$Response(params?: ApiNurseryManagerItemsGetItemsByCategoryPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetItemsByCategoryQueryResult>> {
    return apiNurseryManagerItemsGetItemsByCategoryPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerItemsGetItemsByCategoryPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerItemsGetItemsByCategoryPost(params?: ApiNurseryManagerItemsGetItemsByCategoryPost$Params, context?: HttpContext): Observable<GetItemsByCategoryQueryResult> {
    return this.apiNurseryManagerItemsGetItemsByCategoryPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetItemsByCategoryQueryResult>): GetItemsByCategoryQueryResult => r.body)
    );
  }

  /** Path part for operation `apiNurseryManagerItemsCreateItemPost()` */
  static readonly ApiNurseryManagerItemsCreateItemPostPath = '/api/NurseryManager/Items/CreateItem';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerItemsCreateItemPost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiNurseryManagerItemsCreateItemPost$Plain$Response(params?: ApiNurseryManagerItemsCreateItemPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateItemCommandResult>> {
    return apiNurseryManagerItemsCreateItemPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerItemsCreateItemPost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiNurseryManagerItemsCreateItemPost$Plain(params?: ApiNurseryManagerItemsCreateItemPost$Plain$Params, context?: HttpContext): Observable<CreateItemCommandResult> {
    return this.apiNurseryManagerItemsCreateItemPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateItemCommandResult>): CreateItemCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerItemsCreateItemPost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiNurseryManagerItemsCreateItemPost$Response(params?: ApiNurseryManagerItemsCreateItemPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateItemCommandResult>> {
    return apiNurseryManagerItemsCreateItemPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerItemsCreateItemPost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiNurseryManagerItemsCreateItemPost(params?: ApiNurseryManagerItemsCreateItemPost$Params, context?: HttpContext): Observable<CreateItemCommandResult> {
    return this.apiNurseryManagerItemsCreateItemPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateItemCommandResult>): CreateItemCommandResult => r.body)
    );
  }

  /** Path part for operation `apiNurseryManagerItemsUpdateItemPatch()` */
  static readonly ApiNurseryManagerItemsUpdateItemPatchPath = '/api/NurseryManager/Items/UpdateItem';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerItemsUpdateItemPatch$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiNurseryManagerItemsUpdateItemPatch$Plain$Response(params?: ApiNurseryManagerItemsUpdateItemPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateItemCommandResult>> {
    return apiNurseryManagerItemsUpdateItemPatch$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerItemsUpdateItemPatch$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiNurseryManagerItemsUpdateItemPatch$Plain(params?: ApiNurseryManagerItemsUpdateItemPatch$Plain$Params, context?: HttpContext): Observable<UpdateItemCommandResult> {
    return this.apiNurseryManagerItemsUpdateItemPatch$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateItemCommandResult>): UpdateItemCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerItemsUpdateItemPatch()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiNurseryManagerItemsUpdateItemPatch$Response(params?: ApiNurseryManagerItemsUpdateItemPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateItemCommandResult>> {
    return apiNurseryManagerItemsUpdateItemPatch(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerItemsUpdateItemPatch$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiNurseryManagerItemsUpdateItemPatch(params?: ApiNurseryManagerItemsUpdateItemPatch$Params, context?: HttpContext): Observable<UpdateItemCommandResult> {
    return this.apiNurseryManagerItemsUpdateItemPatch$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateItemCommandResult>): UpdateItemCommandResult => r.body)
    );
  }

  /** Path part for operation `apiNurseryManagerItemsDeleteItemDelete()` */
  static readonly ApiNurseryManagerItemsDeleteItemDeletePath = '/api/NurseryManager/Items/DeleteItem';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerItemsDeleteItemDelete$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerItemsDeleteItemDelete$Plain$Response(params?: ApiNurseryManagerItemsDeleteItemDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteItemCommandResult>> {
    return apiNurseryManagerItemsDeleteItemDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerItemsDeleteItemDelete$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerItemsDeleteItemDelete$Plain(params?: ApiNurseryManagerItemsDeleteItemDelete$Plain$Params, context?: HttpContext): Observable<DeleteItemCommandResult> {
    return this.apiNurseryManagerItemsDeleteItemDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteItemCommandResult>): DeleteItemCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiNurseryManagerItemsDeleteItemDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerItemsDeleteItemDelete$Response(params?: ApiNurseryManagerItemsDeleteItemDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteItemCommandResult>> {
    return apiNurseryManagerItemsDeleteItemDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiNurseryManagerItemsDeleteItemDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiNurseryManagerItemsDeleteItemDelete(params?: ApiNurseryManagerItemsDeleteItemDelete$Params, context?: HttpContext): Observable<DeleteItemCommandResult> {
    return this.apiNurseryManagerItemsDeleteItemDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteItemCommandResult>): DeleteItemCommandResult => r.body)
    );
  }

}
